import React from 'react'
import { Button, Modal, Toast } from "flowbite-react";
import templateModal from '../css/template_modal';
import toast from './toast';

const Modals = ({ isOpen, onClose, title, children, modalSize}) => {
    return (
        <>
            <Modal show={isOpen} size={modalSize} className="p-4" onClose={onClose}>
                <Modal.Header className="p-4">{title}</Modal.Header>
                <Modal.Body>
                    {children}
                    
                </Modal.Body>
            </Modal> 

        </>
    )
}

export default Modals

//<Toast Tipo={"OK"} Mensaje={"Pruebas Toast"} />